export default __webpack_public_path__ + "static/media/no-user-image.b6afe5e8.svg";